import type { IconNode } from '../types';

/**
 * @name butterfly
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUuOCAyQzEyIDMuOCAxMiA5IDEyIDlzMC01LjItMy44LTciIC8+CiAgPHBhdGggZD0iTTEyIDl2MTEiIC8+CiAgPHBhdGggZD0iTTIwIDVjLTMuNSAwLTYuNSAzLjktOCA2LjNDMTAuNSA4LjkgNy41IDUgNCA1YTIgMiAwIDAgMC0yIDJjMCAyLjMuNiA0LjQgMS41IDUuNkM0IDEzLjUgNC45IDE0IDYgMTRoMmMtLjkuNC0yLjEuOS0yLjYgMS41LTEuNiAxLjYtLjkgMy40LjcgNC45IDEuNiAxLjYgMy40IDIuMyA0LjkuNy4zLS4zIDEtMS4xIDEtMS4xcy42LjggMSAxLjFjMS42IDEuNiAzLjQuOSA0LjktLjcgMS42LTEuNiAyLjMtMy40LjctNC45LS41LS41LTEuNy0xLjEtMi42LTEuNWgyYzEuMSAwIDItLjUgMi41LTEuNC45LTEuMiAxLjUtMy4zIDEuNS01LjZhMiAyIDAgMCAwLTItMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/butterfly
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const butterfly: IconNode = [
  ['path', { d: 'M15.8 2C12 3.8 12 9 12 9s0-5.2-3.8-7', key: 'maadmv' }],
  ['path', { d: 'M12 9v11', key: '1fnkrn' }],
  [
    'path',
    {
      d: 'M20 5c-3.5 0-6.5 3.9-8 6.3C10.5 8.9 7.5 5 4 5a2 2 0 0 0-2 2c0 2.3.6 4.4 1.5 5.6C4 13.5 4.9 14 6 14h2c-.9.4-2.1.9-2.6 1.5-1.6 1.6-.9 3.4.7 4.9 1.6 1.6 3.4 2.3 4.9.7.3-.3 1-1.1 1-1.1s.6.8 1 1.1c1.6 1.6 3.4.9 4.9-.7 1.6-1.6 2.3-3.4.7-4.9-.5-.5-1.7-1.1-2.6-1.5h2c1.1 0 2-.5 2.5-1.4.9-1.2 1.5-3.3 1.5-5.6a2 2 0 0 0-2-2',
      key: '15mt2p',
    },
  ],
];

export default butterfly;
